<template>
  <div v-if="!isShowingLoading" :class="$style['container']">
    <SideBar />

    <div :class="[$style['content'], {[$style['menuExpaned']]: isMenuExpanded}]">

      <TransactionsInfo :total-deposits="totalDeposits" :total-withdrawals="totalWithdrawals" :net-total="netTotal" />
  
      <TransactionTable />
  
    </div>

  </div>
</template>

<script>

import SideBar from '@components/SideBar.vue';
import TransactionsInfo from '@/components/transactions/TransactionsInfo.vue';
import TransactionTable from '@/components/transactions/TransactionsTable.vue';
import transactionsService from '@/services/transactionsService';

export default {
  name: 'TransactionsPage',

  data() {
    return {
      totalDeposits: 0,
      totalWithdrawals: 0,
      netTotal: 0,
      transactions: []
    };
  },

  components: {
    SideBar,
    TransactionsInfo,
    TransactionTable,
  },

  async mounted() {
    await this.fetchData()
  },

  computed: {
    isMenuExpanded() {
      return this.$store.getters['helpers/isMenuExpanded'];
    },
    isShowingLoading() {
      return this.$store.getters['helpers/isShowingLoading'];
    },
  },

  methods: {
    async fetchData() {
      this.$store.dispatch('helpers/showLoading')

      try {
        const transactionsInfo = await transactionsService.getTransactionsInfo();

        this.totalDeposits = transactionsInfo.total_deposit
        this.totalWithdrawals = transactionsInfo.total_withdraw
        this.netTotal = transactionsInfo.difference


        this.$store.dispatch('helpers/hideLoading')
      } catch (error) {
        this.totalDeposits = null
        this.totalWithdrawals = null
        this.netTotal = null

        this.$store.dispatch('helpers/hideLoading')
      }
    },
  }
}
</script>

<style lang="scss" module>
  .container {
    // padding: 32px;
    width: 100%;
    display: flex;

    .content {
      flex: 1;
      padding: 20px 20px 20px 0;
      overflow-x: hidden;
      overflow-y: scroll;

      &.menuExpaned {
        position: absolute;
        margin-left: 45px;
        width: -webkit-fill-available;

        .wrapper-report {
          position: absolute;
          width: 90%;
        }
      }

      .wrapper-report {
        display: flex;
        flex-direction: column;
        gap: 25px;
        flex-wrap: wrap;
        margin-top: 20px;
      }
    }

  }
</style>
